import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { CaptionText, H3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { Table } from './Portfolio.styled';

export const RioCalculator = ({
  setCalculator
}: {
  setCalculator: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('my_hubs');
  return (
    <div>
      <H3 mb='20' center>
        {t('rio_calculator.calculate_roi')}
      </H3>
      <Table>
        <thead>
          <tr>
            <th>{t('rio_calculator.timeframe')}</th>
            <th>ROI</th>
            <th> {t('rio_calculator.ulx_per')} $1000</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1d</td>
            <td>0.2%</td>
            <td>3.46</td>
          </tr>
          <tr>
            <td>7d</td>
            <td>1.7%</td>
            <td>24.27</td>
          </tr>
          <tr>
            <td>30d</td>
            <td>7.3%</td>
            <td>104.32</td>
          </tr>
          <tr>
            <td>365d (API)</td>
            <td>92.9%</td>
            <td>1322.4</td>
          </tr>
        </tbody>
      </Table>
      <CaptionText center mt='20'>
        {t('rio_calculator.calculation')}
      </CaptionText>
      <Flexed center column>
        <Button mt='40' onClick={() => setCalculator(false)}>
          {t('rio_calculator.calculate_roi')}
        </Button>
      </Flexed>
    </div>
  );
};
